export default __webpack_public_path__ + "static/media/logo_cume _blanco.a5e2f530.png";